export default function HamburgerIcon({ color = 'white', size = 22 }) {
  return (
    <svg width={size} height={size * 0.73} viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0" y1="1" x2="22" y2="1" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <line x1="8" y1="8" x2="22" y2="8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <line x1="0" y1="15" x2="22" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}
